module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.207718bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-arrow-right.svg
// module id = 1844
// module chunks = 0